import React, { useEffect } from 'react';
import { useInView as defaultUseInView } from 'react-intersection-observer';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';
import { track } from 'apis/amethyst';
import { evRecommendationImpressionWrapper } from 'events/recommendations';
import ProductCard from 'components/common/ProductCard';

import css from 'styles/components/search/sponsoredAds.scss';

const SponsoredAdsProduct = ({
  product,
  numSponsoredAds,
  trackSponsoredAdImpressions,
  makeSponsoredAdClick,
  msaImageParams,
  CardBottomSlot,
  isInCarousel,
  isFullMaxWidth,
  useInView = defaultUseInView
}) => {
  const { testId } = useMartyContext();
  const [intersectionRef, inView] = useInView({
    threshold: 0.3 /** 30% was the agreed upon spec from MSFT to fire the view event */,
    triggerOnce: true
  });
  const { viewUrl, index } = product;
  const linkProps = { 'aria-describedby': `sponsoredBanner-${index}` };

  /**
   * Important: "View" events are fired when a customer has the ad in the viewport, via intersection observer
   */
  useEffect(() => {
    if (inView) {
      const recommendationImpression = [
        {
          numberOfRecommendations: numSponsoredAds,
          recommendationType: 'PRODUCT_RECOMMENDATION',
          recommendationSource: 'MICROSOFT',
          widgetType: 'MICROSOFT_TOP_BLOCK'
        }
      ];

      track(() => [evRecommendationImpressionWrapper, { recommendationImpression, products: [product] }]);
      trackSponsoredAdImpressions({ url: viewUrl });
    }
  }, [inView, trackSponsoredAdImpressions, viewUrl, numSponsoredAds, product]);

  return (
    <ProductCard
      intersectionRef={intersectionRef}
      className={cn({
        [css.sponsoredAdsCard]: !isInCarousel,
        [css.sponsoredAdsCarouselCard]: isInCarousel,
        [css.displaySixCardTiles]: isFullMaxWidth
      })}
      msaImageParams={msaImageParams}
      onClick={makeSponsoredAdClick(product, index)}
      {...product}
      data-test-id={testId('msftWrappedCard')}
      CardBottomSlot={CardBottomSlot}
      linkProps={linkProps}
    />
  );
};

export default SponsoredAdsProduct;
